import React, { useCallback } from 'react';
import { ServicesContext } from '../ServicesContext';
import { setRiskGapAnswer } from './utils/setRiskGapAnswer';
import { PatientCacheRef, PatientServiceEvents } from './usePatientService';

export const useLoadPatient = (events: PatientServiceEvents, patientCache: PatientCacheRef) => {
    const services = React.useContext(ServicesContext);

    const loadPatient = useCallback(
        async (id: number, catchMissing?: boolean) => {
            const options: ApiRequestOptionsType = {};
            if (catchMissing) options.handledErrors = { 404: true };

            const result: ApiDataResponseType<PatientType> = await services.api.call(
                {
                    method: 'get',
                    url: `/api/patients/${id}`,
                },
                options
            );

            result.data.risk_gaps = result.data.risk_gaps.map(setRiskGapAnswer);
            patientCache.current[id] = result.data;

            services.events.publish(events.patient_updated);
        },
        [services.api, services.events, events, patientCache]
    );

    return loadPatient;
};
